import { UiService } from '@services/ui.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { Article } from '@classes/article';
import { Tariff } from '@classes/tariff';
import { FilterHelperService } from '../helpers/filter-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ArticlesService {
  articlesListChanged = new Subject<Article[]>();
  articlesFormated: any[] = [];
  articlesFormatedListChanged = new Subject<any[]>();
  private baseUrl: string = environment.apiUrl + 'articles';
  private articles: Article[];

  constructor(
    private http: HttpClient,
    private uiSrv: UiService,
    private _filterHelper: FilterHelperService
  ) { }

  get(idSite: string): Observable<Article[]> {
    return this.http.get<Article[]>(`${this.baseUrl}?siteId=${idSite}`)
      .pipe(
        map(articles => {
          this.articles = articles;
          this.articlesListChanged.next([...this.articles]);
          return [...this.articles];
        })
      );
  }

  getFormated(filters: any, showIncompleteTariffs: boolean): Observable<any[]> {
    let httpParams = new HttpParams();
    const filtersQuery = [];

    if (filters.client) {
      filtersQuery.push(`clientId==${filters.client}`);
    }

    if (filters.site) {
      filtersQuery.push(`siteId==${filters.site}`);
    }

    if (showIncompleteTariffs) {
      filtersQuery.push(`IncompleteTariffs`);
    }

    if (filters.urgency) {
      filtersQuery.push(`urgency@=${filters.urgency}`);
    }

    if (filters.lot) {
      filtersQuery.push(`lot@=${this._filterHelper.formatFilterValue(filters.lot)}`);
    }

    if (filters.sender) {
      filtersQuery.push(`sender@=${filters.sender}`);
    }

    if (filters.step) {
      filtersQuery.push(`step@=${filters.step}`);
    }



    httpParams = httpParams.append("Filters", filtersQuery.join());

    return this.http.get<Article[]>(`${this.baseUrl}`, { params: httpParams })
      .pipe(
        map(articles => {
          this.articles = articles;
          this.articlesFormated = [];
          this.articles.map(article => {

            let stepsFormated = [];

            article.steps.map(step => {
              let daysWeek = {
                dayPrice: null,
                dayPackage: null,
                days: [],
                id: null,
                nightPrice: null,
                nightPackage: null,
              };

              let saturday = {
                dayPrice: null,
                dayPackage: null,
                days: [],
                id: null,
                nightPrice: null,
                nightPackage: null,
              };

              let sunday = {
                dayPrice: null,
                dayPackage: null,
                days: [],
                id: null,
                nightPrice: null,
                nightPackage: null,
              };

              let noDays = {
                dayPrice: null,
                dayPackage: null,
                id: null,
                nightPrice: null,
                nightPackage: null,
              };


              step.tariffs.map(tariff => {
                if (!tariff.days) {
                  noDays.id = tariff.id;
                  noDays.dayPrice = tariff.dayPrice;
                  noDays.dayPackage = tariff.dayPackage;
                  noDays.nightPrice = tariff.nightPrice;
                  noDays.nightPackage = tariff.nightPackage;
                } else if (tariff.days.length === 0) {
                  noDays.id = tariff.id;
                  noDays.dayPrice = tariff.dayPrice;
                  noDays.dayPackage = tariff.dayPackage;
                  noDays.nightPrice = tariff.nightPrice;
                  noDays.nightPackage = tariff.nightPackage;
                } else if (tariff.days[0] === 0) {
                  sunday.id = tariff.id;
                  sunday.days = [0];
                  sunday.dayPrice = tariff.dayPrice;
                  sunday.dayPackage = tariff.dayPackage;
                  sunday.nightPrice = tariff.nightPrice;
                  sunday.nightPackage = tariff.nightPackage;
                } else if (tariff.days[0] === 6) {
                  saturday.id = tariff.id;
                  saturday.days = [6];
                  saturday.dayPrice = tariff.dayPrice;
                  saturday.dayPackage = tariff.dayPackage;
                  saturday.nightPrice = tariff.nightPrice;
                  saturday.nightPackage = tariff.nightPackage;
                } else {
                  daysWeek.id = tariff.id
                  daysWeek.days = tariff.days
                  daysWeek.dayPrice = tariff.dayPrice;
                  daysWeek.dayPackage = tariff.dayPackage;
                  daysWeek.nightPrice = tariff.nightPrice;
                  daysWeek.nightPackage = tariff.nightPackage;
                }
              })
              let stepFormated = {
                id: step.id,
                address: step.address,
                otherAddress: step.otherAddress,
                hasPhoto: step.hasPhoto,
                hasSignature: step.hasSignature,
                isDelivery: step.isDelivery,
                isPickup: step.isPickup,
                daysWeek: daysWeek,
                saturday: saturday,
                sunday: sunday,
                noDays: noDays
              };

              stepsFormated.push(stepFormated);
            })


            let articleFormated = {
              id: article.id,
              sender: article.sender,
              site: article.site,
              urgency: article.urgency,
              lot: article.lot,
              stepsFormated: stepsFormated,
              code: article.code,
              estimatedTime: article.estimatedTime,
            };

            this.articlesFormated.push(articleFormated);
          })
          return [...this.articlesFormated];
        })
      );
  }

  updateList() {
    this.articlesFormated = [];
    this.articles.map(article => {

      let stepsFormated = [];

      article.steps.map(step => {
        let daysWeek = {
          dayPrice: null,
          dayPackage: null,
          days: [],
          id: null,
          nightPrice: null,
          nightPackage: null,
        };

        let saturday = {
          dayPrice: null,
          dayPackage: null,
          days: [],
          id: null,
          nightPrice: null,
          nightPackage: null,
        };

        let sunday = {
          dayPrice: null,
          dayPackage: null,
          days: [],
          id: null,
          nightPrice: null,
          nightPackage: null,
        };

        let noDays = {
          dayPrice: null,
          dayPackage: null,
          id: null,
          nightPrice: null,
          nightPackage: null,
        };


        step.tariffs.map(tariff => {
          if (!tariff.days) {
            noDays.id = tariff.id;
            noDays.dayPrice = tariff.dayPrice;
            noDays.dayPackage = tariff.dayPackage;
            noDays.nightPrice = tariff.nightPrice;
            noDays.nightPackage = tariff.nightPackage;
          } else if (tariff.days.length === 0) {
            noDays.id = tariff.id;
            noDays.dayPrice = tariff.dayPrice;
            noDays.dayPackage = tariff.dayPackage;
            noDays.nightPrice = tariff.nightPrice;
            noDays.nightPackage = tariff.nightPackage;
          } else if (tariff.days[0] === 0) {
            sunday.id = tariff.id;
            sunday.days = [0];
            sunday.dayPackage = tariff.dayPackage;
            sunday.dayPrice = tariff.dayPrice;
            sunday.nightPrice = tariff.nightPrice;
            sunday.nightPackage = tariff.nightPackage;
          } else if (tariff.days[0] === 6) {
            saturday.id = tariff.id;
            saturday.days = [6];
            saturday.dayPrice = tariff.dayPrice;
            saturday.dayPackage = tariff.dayPackage;
            saturday.nightPrice = tariff.nightPrice;
            saturday.nightPackage = tariff.nightPackage;
          } else {
            daysWeek.id = tariff.id
            daysWeek.days = tariff.days
            daysWeek.dayPrice = tariff.dayPrice;
            daysWeek.dayPackage = tariff.dayPackage;
            daysWeek.nightPrice = tariff.nightPrice;
            daysWeek.nightPackage = tariff.nightPackage;
          }
        })

        let stepFormated = {
          id: step.id,
          address: step.address,
          otherAddress: step.otherAddress,
          hasPhoto: step.hasPhoto,
          hasSignature: step.hasSignature,
          isDelivery: step.isDelivery,
          isPickup: step.isPickup,
          daysWeek: daysWeek,
          saturday: saturday,
          sunday: sunday,
          noDays: noDays
        };

        stepsFormated.push(stepFormated);
      })


      let articleFormated = {
        id: article.id,
        sender: article.sender,
        site: article.site,
        urgency: article.urgency,
        lot: article.lot,
        code: article.code,
        stepsFormated: stepsFormated,
        estimatedTime: article.estimatedTime,
      };


      this.articlesFormated.push(articleFormated);
    })
    this.articlesFormatedListChanged.next([...this.articlesFormated]);
  }


  put(article: Article): Observable<Article> {
    return this.http.put<Article>(this.baseUrl, article)
      .pipe(
        tap(editedArticle => {
          this.articles = this.articles.map(c => c.id === editedArticle.id ? editedArticle : c);
          this.articlesListChanged.next([...this.articles]);
          this.uiSrv.showSnackbar('Article édité avec succès', false);
        })
      );
  }

  post(article: Article): Observable<Article> {
    return this.http.post<Article>(this.baseUrl, article)
      .pipe(
        tap(createdarticle => {
          this.articles.push(createdarticle);
          this.articlesListChanged.next([...this.articles]);
        })
      );
  }

  putStepArticle(articleId: string, stepId: string, tariffs: Tariff[]): Observable<any> {
    return this.http.put<Tariff[]>(`${this.baseUrl}/${articleId}/steps/${stepId}/tariffs`, tariffs)
      .pipe(
        tap(editedArticle => {
          this.articles = this.articles.map(c => c.id === editedArticle.id ? editedArticle : c);
          this.articlesListChanged.next([...this.articles]);
          this.updateList();
          this.uiSrv.showSnackbar('Article édité avec succès', false);
        })
      );
  }

  public patchCodeArticle(articleId: string, code: string): Observable<Article> {
    return this.http.patch<Article>(`${this.baseUrl}/${articleId}/code`, { code: code })
      .pipe(
        tap(editedArticle => {
          this.articles = this.articles.map(c => c.id === editedArticle.id ? editedArticle : c);
          this.articlesListChanged.next([...this.articles]);
          this.updateList();
          this.uiSrv.showSnackbar('Code article édité avec succès', false);
        })
      );
  }

  generateArticles(siteId?: string, clientId?: string): Observable<any> {
    const params = siteId ? `siteId=${siteId}` : `clientId=${clientId}`;
    return this.http.post<any>(`${this.baseUrl}/generate?${params}`, null);
  }

  generateArticleByOrderId(orderId: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/generate?orderId=${orderId}`, null)
      .pipe(
        tap(() => {
          this.uiSrv.showSnackbar('Article généré avec succès', false);
        })
      );
  }

  // DELETE

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
        tap(() => {
          this.articles = this.articles.filter(c => c.id !== id);
          this.articlesListChanged.next([...this.articles]);
          this.updateList();
        })
      );
  }

  public patchEstimatedTime(articleId: string, estimatedTime: number): Observable<Article> {
    return this.http.patch<Article>(`${this.baseUrl}/${articleId}/estimated-time`, { estimatedTime })
      .pipe(
        tap((editedArticle: Article) => {
          this.articles = this.articles.map(c => c.id === editedArticle.id ? editedArticle : c);
          this.articlesListChanged.next([...this.articles]);
          this.updateList();
          this.uiSrv.showSnackbar('Temps estimé édité avec succès', false);
        })
      );
  }
}
